import React from 'react'
import styled from 'styled-components'
import {
  ActionCell,
  DateCell,
  NameCell,
  OfrIterationFilename,
  RunCountCell,
  StatusCell,
} from './SmartFunctionPanelTableRow'
import { t } from 'i18next'
import { useParams } from 'react-router-dom'
import { useWorkspaceDetails } from '../../../hooks'
import { workspaceTypes } from '../../../constants/constants'

const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  font-family: Inter;
  height: 48px;
`

export const SmartFunctionPanelTableHeader = () => {
  const { workspaceId } = useParams()
  const { selectedWorkspace } = useWorkspaceDetails({
    workspaceId,
    preventFetch: true,
  })
  return (
    <HeaderRow key={'header'}>
      <NameCell>{t('Name')}</NameCell>
      {selectedWorkspace?.typeCode === workspaceTypes.OFR_QR && (
        <OfrIterationFilename>
          {t('workspaceDetailsPage.workspaceSmartFunctionPanel.template')}
        </OfrIterationFilename>
      )}
      <DateCell>{t('Date')}</DateCell>
      <RunCountCell>
        {t('workspaceDetailsPage.workspaceSmartFunctionPanel.runNumber')}
      </RunCountCell>
      <StatusCell>{t('Status')}</StatusCell>
      <ActionCell></ActionCell>
    </HeaderRow>
  )
}
